import BidEstimateIconRed from "@/assets/images/Tab/bid-estimate-icon-red.png";
import Card from "@/components/Common/Card";
import { Button } from "@/components/ui/button";
import EstimateCreateDialog from "./EstimateCreateDialog";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import {
  useCreateProjectGroupsItemSheets,
  useReadItemsheetInProgressCount,
} from "@/libs/react-query/hooks/useItemsheetsQuery";
import { useParams } from "react-router-dom";
import { useSelectedProjectInfo } from "../hooks/useTabStore";
import { showToast } from "@/utils/toastUtils";

export default function BeforeEstimate() {
  const { group_id = "" } = useParams();

  const selectedProjectInfo = useSelectedProjectInfo();
  const { projectId, projectType } = selectedProjectInfo || {};

  const { mutate: createItemSheet } =
    useCreateProjectGroupsItemSheets(group_id);
  const { data: inProgress } = useReadItemsheetInProgressCount(group_id);

  const isLimitReached =
    inProgress != null && inProgress.count >= inProgress.limit;

  const onSubmit = (data: { estimateName: string }) => {
    if (!projectId || !projectType) {
      return;
    }

    createItemSheet(
      {
        project_id: projectId,
        project_type: projectType,
        title: data.estimateName,
      },
      {
        onError: (error: any) => {
          showToast({
            message: "산출내역서 생성에 실패했습니다.",
            type: "error",
            description: error?.response?.data?.display_message || "",
          });
        },
      }
    );
  };

  return (
    <Card icon={BidEstimateIconRed} title="산출내역서">
      <div className="w-full h-full flex flex-col items-center justify-center">
        <div className="flex flex-col w-full h-full items-center justify-center gap-5 py-14">
          <Dialog>
            <DialogTrigger asChild>
              <Button
                type="button"
                size="lg"
                className="bg-dark-brown hover:bg-dark-brown/80 rounded-full shadow-md"
                disabled={!selectedProjectInfo}
              >
                <span className="text-2xl text-white font-bold">
                  산출내역서 생성하기
                </span>
              </Button>
            </DialogTrigger>
            <EstimateCreateDialog onSubmit={onSubmit} />
          </Dialog>
          {selectedProjectInfo ? (
            <p className="text-lg text-gray-B font-semibold">
              산출내역서가 생성되기까지 오랜 시간이 소요될 수 있습니다
            </p>
          ) : (
            <p className="text-lg text-gray-B font-semibold">
              산출내역서를 생성하려면 먼저 공고를 선택해 주세요.
            </p>
          )}
          {inProgress != null && (
            <div className="flex flex-col items-center gap-1">
              <p className="text-sm text-gray-B font-medium">
                현재 생성 진행 중인 산출내역서: {inProgress.count}/
                {inProgress.limit}건
              </p>
              {isLimitReached && (
                <p className="text-sm text-amber-600 font-semibold">
                  동시에 최대 {inProgress.limit}건까지 생성할 수 있어요. 진행
                  중인 생성이 완료된 후 시도해 주세요.
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
